import { useLocation } from "@tanstack/react-router";
import { useEffect, useRef, useState, type PropsWithChildren } from "react";

import { sidebarTabContext } from "src/components/sidebarTabContext";
import { type SidebarTabConfig, type SidebarTabsConfig } from "src/staticData";

interface SidebarTabProviderProps extends PropsWithChildren {
  tabs: SidebarTabsConfig;
}

function getActiveSidebarTab(
  tabs: SidebarTabsConfig,
  pathname: string,
): SidebarTabConfig | null {
  const match = { pathname: pathname };
  const activeTab = tabs.items.find((item) => {
    return item.activeWhen?.(match) === true;
  });

  return activeTab ?? null;
}
export function SidebarTabProvider(props: SidebarTabProviderProps) {
  const pathname = useLocation({
    select: (loc) => {
      return loc.pathname;
    },
  });
  const previousPathnameRef = useRef(pathname);

  const [tab, setTab] = useState<string>(() => {
    const activeTab = getActiveSidebarTab(props.tabs, pathname);
    return activeTab?.value ?? props.tabs.defaultValue;
  });

  useEffect(() => {
    if (previousPathnameRef.current === pathname) {
      return;
    }

    previousPathnameRef.current = pathname;
    const activeTab = getActiveSidebarTab(props.tabs, pathname);

    if (activeTab) {
      setTab(activeTab.value);
    }
  }, [props.tabs, pathname]);

  return (
    <sidebarTabContext.Provider value={{ tab: tab, setTab: setTab }}>
      {props.children}
    </sidebarTabContext.Provider>
  );
}
